import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SiteServices } from '../../services/siteservices';
import { PaginationModule } from 'ngx-bootstrap';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ChartsModule } from 'ng2-charts';

import { DecimalOnlyDirective } from '../../directives/decimalonly.directive';
import { IntegerOnlyDirective } from '../../directives/integeronly.directive';
import { CurrencyOnlyDirective } from '../../directives/currencyonly.directive';
import { HUFPipe } from '../../pipes/huf.pipe';
import { RoundPipe } from '../../pipes/round.pipe';
import { FileUploadModule } from 'ng2-file-upload';

import { RouteReuseStrategy } from '@angular/router';
import { ROOTAPPNEW_ROUTER_PROVIDERS } from './providerproductdetail.routes';

import { CustomReuseStrategy } from '../common/route.reuse';

//import { SimpleModalComponent } from 'ngx-modal-dialog';
import { ModalDialogModule } from 'ngx-modal-dialog';

import { ProviderProductDetailComponent } from './providerproductdetail.main';
import { ProviderProductDetailFrm } from './providerproductdetail.frm';

@NgModule({
    declarations: [
        ProviderProductDetailComponent,
        ProviderProductDetailFrm,
        DecimalOnlyDirective,
        IntegerOnlyDirective,
        CurrencyOnlyDirective,

        HUFPipe,
        RoundPipe,
    ],
    imports: [
        ChartsModule,
        CommonModule,
        ROOTAPPNEW_ROUTER_PROVIDERS,
        FormsModule,
        HttpModule,
        FileUploadModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        ModalDialogModule.forRoot(),
    ],
    providers: [
        SiteServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [ProviderProductDetailComponent],
})
export class ProviderProductDetailModule {}
